import { defaultAction } from "./defaultAction";
import { SET_CARD_KNOX_FORM } from "@constants/actionTypes";
export const handleCardKnoxForm = event => async (dispatch, getState, api) => {
  await dispatch(defaultAction(SET_CARD_KNOX_FORM, event));
  return await dispatch(getCardKnoxState());
};

export const getCardKnoxState = () => async (dispatch, getState, api) => {
  return getState().cardKnox;
};
